(function($){
    var ucs = null;

    var slidesImages = null;

    var slidestextes = null;

    var boutonSuiv = null;

    var boutonPrec = null;

    var imageActive = 0;


    $(document).ready(function(){
        ucs = $('.UserCommentairesSlider')[0];

        slidesImages = $('.UserCommentairesSlider .ucs-imagesConteneur img');

        slidestextes = $('.UserCommentairesSlider .ucs-commentaires .ucs-commentaire');

        boutonPrec = $('.UserCommentairesSlider .ucs-navigation-gauche')[0];

        boutonSuiv = $('.UserCommentairesSlider .ucs-navigation-droite')[0];

        $(boutonSuiv).click(function(e){
            e.preventDefault();
            e.stopPropagation();
            imageActive++;

            if(imageActive >= slidesImages.length) {
                imageActive = 0;
            }

            slidesImages.each(function(){
                if(!$(this).hasClass('hidden')) {
                    $(this).addClass('hidden');
                }
            });

            $(slidesImages[imageActive]).removeClass('hidden');

            slidestextes.each(function(){
                if(!$(this).hasClass('hidden')) {
                    $(this).addClass('hidden');
                }
            });

            $(slidestextes[imageActive]).removeClass('hidden');
        });

        $(boutonPrec).click(function(e){
            e.preventDefault();
            e.stopPropagation();
            imageActive--;

            if(imageActive < 0) {
                imageActive = slidesImages.length-1;
            }

            slidesImages.each(function(){
                if(!$(this).hasClass('hidden')) {
                    $(this).addClass('hidden');
                }
            });

            $(slidesImages[imageActive]).removeClass('hidden');

            slidestextes.each(function(){
                if(!$(this).hasClass('hidden')) {
                    $(this).addClass('hidden');
                }
            });

            $(slidestextes[imageActive]).removeClass('hidden');
        });

        var site_header = $('.site-header')[0];

        var site_header_height = $(site_header).height();

        var the_window_width = $(window).width();

        var position_top_raccourci = $(".site-header").offset().top;


        $(window).scroll(function () {
            site_header_height = $(site_header).height();

            the_window_width = $(window).width();

            if ($(this).scrollTop() > 150 && (the_window_width > 768)) {
                $(site_header).addClass("f-nav");
            } else {
    			$(site_header).removeClass("f-nav");
    		}
    	});
    });
})(jQuery);
